import { patchWindowDotPlaid } from './cookie';
import { setupDocsPathListener } from './docs';
import { trackingUtils, trackPageView } from './track';

const initAnalytics = () => {
  patchWindowDotPlaid();
  setupDocsPathListener();
  trackingUtils();
  trackPageView();
};

export default initAnalytics;
